<template>
    <div>
        <h3>Tenants
            <v-btn icon @click="refreshData">
                <v-icon>fas fa-redo-alt</v-icon>
            </v-btn>
        </h3>
        <v-text-field dense v-model="search" append-icon="icon-q-search" label="Search" single-line hide-details v-on:keyup="maybeSearch" @click:append="refreshData"></v-text-field>
        <v-data-table v-on:current-items="updateCurrentItems" :mobile-breakpoint="2" :items-per-page.sync="rows" :search="search" v-model="selected" :headers="the_headers" :items="all_data" item-key="id" class="elevation-0" :footer-props="{itemsPerPageOptions:[10,25,50,100]}" :loading="loading" :options.sync="options" :server-items-length="total_items">
            <template v-slot:item.TenantId="{ item }">
                {{item.ID}}
            </template>
            <template v-slot:item.ID="{ item }">
                <span class="nowrap">
                    <v-btn icon @click="$emit('edit', item.ID)" color="primary" title="Edit">
                        <v-icon>fas fa-edit</v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="!item.EnabledInd"
                        icon
                        color="primary"
                        title="Impersonate"
                        @click="impersonateTopLevelAgent(item.TopLevelAgentCode)"
                    >
                        <v-icon>fas fa-user</v-icon> 
                    </v-btn>
                </span>
            </template>
            <template v-slot:item.EnabledInd="{ item }">
                <v-switch v-model="item.EnabledInd" v-on:change="toggleTenant(item)"></v-switch>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import QGenericDataTableMixin from "./QGenericDataTableMixin"
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
import Tenant from '@/store/Models/Tenant'
export default {
    name: "QTenantDataTable",
    props: [],
    mixins: [QGenericDataTableMixin],
    data: function() { // data internal to component (not available outside)
        return {
            //use this to "preset" a filter
            filters: {},
            options: {
                'sortBy': [],
                'sortDesc': [true]
            },
            expanded: [],
        }
    },
    computed: {
        loading: function() {
            return this.data_loading;
        },
        all_data: function() {
            return this.the_data;
        },
        filter_keys: function() {
            return [];
        },
        total_items: function() {
            return this.total_num;
        },
        the_headers: function() {
            return [{
                    text: 'Tenant ID',
                    value: 'TenantId',
                    align: "center"
                },
                {
                    text: 'Tenant',
                    value: 'Tenant',
                }, {
                    text: 'Prefix',
                    value: 'AgentCodePrefix',
                    align: "center"
                }, {
                    text: 'Url',
                    value: 'TenantBaseURL',
                    align: "left"
                }, {
                    text: 'Enabled',
                    value: 'EnabledInd',
                    align: "left"
                }, {
                    text: '',
                    value: 'ID',
                },

            ]
        },
    },
    methods: {
        loadData: debounce(function(opt) {
            var g = this
            this.data_loading = true
            QuilityAPI.getTenants().then(function(json) {
                g.data_loading = false
                if (typeof json.response != 'undefined' && json.response.clientError) {
                    g.showError(json.response.body.message);
                    return
                }
                g.$set(g, 'the_data', json.data);
                g.total_num = json.total
            }).catch(function(err) {
                g.data_loading = false
                if (err.status == 431) {
                    g.showError(err + " You probably need to clear all your cookie and session variables and login again.")
                    return
                }
                g.showError(err.message);
            });
            this.firstPull = false;
        }, 200),
        toggleTenant(item) {
            var tenant = { EnabledInd: item.EnabledInd ? 1 : 0 };
            var g = this
            this.data_loading = true
            QuilityAPI.saveTenant(item.ID, tenant).then(function(resp) {
                    if (resp.success !== true) {
                        g.error = resp.msg
                        setTimeout(function() { g.error = null }, 6000)
                    } else {
                        Tenant.insert({ data: resp.data })
                    }
                    g.data_loading = false
                })
                .catch(function(err) {
                    console.log(err)
                    g.error = err.msg
                    setTimeout(function() { g.error = null }, 6000)
                    g.saving = false;
                });
        },
        impersonateTopLevelAgent(agent_code) {
            var g = this
            this.data_loading = true
            QuilityAPI.impersonateTopLevelAgent(agent_code).then(function(resp) {
                    if (resp.success !== true) {
                        g.error = resp.msg
                        setTimeout(function() { g.error = null }, 6000)
                    } 
                    else {
                        g.data_loading = false
                        g.showSuccess("Successfully Impersonated!")
                        if (window.location.hostname == "localhost") {
                            document.location.href = "http://localhost:8080";
                        } else {
                            document.location.href = 'https://' + window.location.hostname;
                        }
                    }
                    g.data_loading = false
                })
                .catch(function(err) {
                    console.log(err)
                    g.error = err.msg
                    setTimeout(function() { g.error = null }, 6000)
                });
        }
        
    },
    watch: {

    },
    components: {}
}
</script>
<style scoped>
.nowrap {
    white-space: nowrap;
}
</style>